<div class="flex justify-center items-center flex-col h-full text-center" *transloco="let t">
	<vis-ods-icon-component
		[name]="'success'"
		class="mb-m"
		width="72px"
		height="72px"
	></vis-ods-icon-component>
	<beyond-online-headline
		[headline]="t('generalComponents.singleOrderSubmitSuccessPopUp.headlines.title')"
		[subHeadline]="t('generalComponents.singleOrderSubmitSuccessPopUp.headlines.subtitle')"
		size="xl"
	></beyond-online-headline>

	<p beyond-online-text class="text-body-l mb-s mt-l">
		{{ t('generalComponents.singleOrderSubmitSuccessPopUp.texts.message') }}
	</p>
	<button
		beyond-online-button
		[attr.data-testid]="'new-order-button'"
		variant="primary"
		(click)="goToNewOrder()"
		class="w-full justify-center"
		[label]="t('generalComponents.singleOrderSubmitSuccessPopUp.buttons.newOrder')"
	></button>
	<button
		beyond-online-button
		(click)="goToMyZeiss()"
		class="w-full my-xs justify-center"
		variant="secondary"
		[label]="t('generalComponents.singleOrderSubmitSuccessPopUp.buttons.myOrders')"
	></button>
</div>
